import { Injectable } from '@angular/core';
import posthog from 'posthog-js';

import { environment } from '../../../environments/environment'; // Adjust path if needed

@Injectable({
  providedIn: 'root',
})
export class PosthogService {
  // TODO: enableTracking should be configurable only on production
  private readonly enableTracking = environment.envName === 'PRO';
  constructor() {
    if (this.enableTracking) {
      this.init();
    }
  }

  private init(): void {
    // Check if PostHog is already initialized (useful for HMR or potential double-init scenarios)
    if (typeof window !== 'undefined' && !posthog.__loaded) {
      posthog.init(environment.posthogApiKey, {
        // Using environment variable for key
        api_host: environment.posthogApiHost, // Using environment variable for host
        // Enable session recording - can be controlled via PostHog UI as well
        // capture_pageview: false, // We will capture pageviews manually on route changes
        loaded: () => {
          console.log('PostHog loaded');

          if (this.enableTracking === false) {
            // posthog.opt_out_capturing(); // Optional: Opt out of tracking in dev environments (use posthog directly if needed)
            console.log('PostHog loaded (dev mode, opted out)');
          } else {
            console.log('PostHog loaded');
          }
        },
      });
    }
  }

  // Method to identify the user after login
  identifyUser(userId: string, traits?: Record<string, unknown>): void {
    // Changed any to unknown
    if (this.enableTracking) {
      // Only identify in production
      posthog.identify(userId, traits);
      console.log(`PostHog user identified: ${userId}`);
    }
  }

  // Method to reset user identification on logout
  resetUser(): void {
    if (this.enableTracking) {
      posthog.reset();
      console.log('PostHog user reset (logout)');
    }
  }

  // Method to capture custom events
  captureEvent(eventName: string, properties?: Record<string, unknown>): void {
    // Changed any to unknown
    if (this.enableTracking) {
      // Only capture in production
      posthog.capture(eventName, properties);
      console.log(`PostHog event captured: ${eventName}`, properties);
    }
  }

  // Method specifically for capturing page views on route changes
  capturePageView(): void {
    if (this.enableTracking) {
      posthog.capture('$pageview');
      console.log('PostHog pageview captured');
    }
  }
}
